import type { Query, QueryClient } from '@tanstack/react-query';
import type { ContentObjectDetail, ContentObjectList } from 'models';
import type { InfiniteData } from 'query';
import { getContentObjectFeatureKey, getContentObjectsInfiniteQueryKey, getFeedKey } from '../queries/keys';

type PatchContentObjectCommentsCountParams = {
  delta: number;
  id: string;
  queryClient: QueryClient;
};

export const patchContentObjectCommentsCount = ({ delta, id, queryClient }: PatchContentObjectCommentsCountParams) => {
  queryClient.setQueriesData<ContentObjectDetail>(
    {
      predicate(query: Query) {
        if (query.queryKey[0] !== getContentObjectFeatureKey()[0] || query.queryKey[1] !== 'detail') {
          return false;
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- TODO: fix, cached detail query data isn't typed
        const contentObject = query.state.data as ContentObjectDetail | undefined;

        return contentObject?.id === id;
      },
    },
    (contentObject) => contentObject && { ...contentObject, commentsCount: contentObject.commentsCount + delta },
  );

  for (const queryKey of [getFeedKey(), getContentObjectsInfiniteQueryKey({})]) {
    queryClient.setQueriesData({ queryKey }, (oldData?: InfiniteData<Array<Record<string, unknown>>>) => {
      if (!oldData) {
        return oldData;
      }

      return {
        ...oldData,
        pages: oldData.pages.map((page) =>
          page.map((item) => {
            if (item.id !== id) {
              return item;
            }

            /* eslint-disable @typescript-eslint/naming-convention -- Legacy program feed data isn't transformed to camelCase */
            if (typeof item.comments_count === 'number') {
              return { ...item, comments_count: item.comments_count + delta };
            }
            /* eslint-enable @typescript-eslint/naming-convention -- Legacy program feed data isn't transformed to camelCase */

            // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- narrowed by the check above being false
            const contentObject = item as unknown as ContentObjectList;

            return { ...contentObject, commentsCount: contentObject.commentsCount + delta };
          }),
        ),
      };
    });
  }
};
